import axios from '../axios'

/*
 * 财务管理模块
 */

export const selectByPage = (data) => {
    return axios({
        url: '/admin/withdrawApply/selectByPage',
        method: 'post',
        data
    })
}
export const approveSuccess = (data) => {
    return axios({
        url: '/admin/withdrawApply/approveSuccess',
        method: 'post',
        data
    })
}
export const approveFail = (data) => {
    return axios({
        url: '/admin/withdrawApply/approveFail',
        method: 'post',
        data
    })
}

export const selectError = (data) => {
    return axios({
        url: '/admin/withdrawPayment/selectError',
        method: 'post',
        data
    })
}
export const batchRepay = (data) => {
    return axios({
        url: '/admin/withdrawPayment/batchRepay',
        method: 'post',
        data
    })
}
export const selectWithdraw = (data) => {
    return axios({
        url: '/admin/withdrawPayment/selectWithdraw',
        method: 'post',
        data
    })
}

export const batchApply = (data) => {
    return axios({
        url: '/admin/withdrawApply/batchApply',
        method: 'post',
        data
    })
}


// WEBPACK FOOTER //
// ./src/http/moudules/finance.js